import { isPlatformServer } from '@angular/common';
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { makeStateKey, StateKey, TransferState } from '@angular/platform-browser';
import { NbAuthService, NbAuthToken, NB_AUTH_TOKEN_INTERCEPTOR_FILTER } from '@nebular/auth';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestInterceptorService {

  constructor(
    private injector: Injector,
    @Inject(NB_AUTH_TOKEN_INTERCEPTOR_FILTER) protected filter,
    private transferState:TransferState,
    @Inject(PLATFORM_ID) private platformId:any
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
    //console.log("fucking intercepting poes");
    console.log("Request: "+req.url);
    let auth_app_token = JSON.parse(localStorage.getItem('auth_app_token'));
    const key: StateKey<string> = makeStateKey<string>(req.url);
    if(auth_app_token){
      //console.log(auth_app_token);
      // do not intercept request whose urls are filtered by the injected filter
      if (!this.filter(req)){
        console.log("Not filtered poes: "+req);
        return this.authService.isAuthenticatedOrRefresh()
          .pipe(
            switchMap(authenticated => {
              if(authenticated){
                return this.authService.getToken().pipe(
                  switchMap((token: NbAuthToken) => {
                    const JWT = `Bearer ${token.getValue()}`;
                    req = req.clone({
                      setHeaders: {
                        Authorization: JWT,
                      },
                    });
                    if(req.method !== 'GET'){
                      return next.handle(req);
                    }else{
                      return this.preventDuplicate(key,req,next);
                    }
                  }),
                )
              }else{
                // Request is sent to server without authentication so that the client code
                // receives the 401/403 error and can act as desired ('session expired', redirect to login, aso)
                if(req.method !== 'GET'){
                  return next.handle(req);
                }else{
                  this.preventDuplicate(key,req,next);
                }
                //return next.handle(req);
              }
            }),
          )

      }else if(req.url.match(/api\//)){
        console.log("Filtered doos: "+req);
        if(req.method !== 'GET'){
          return next.handle(req);
        }else{
          return this.preventDuplicate(key,req,next);
        }
        //return next.handle(req);
      }else{
        console.log("Filtered doos not matching path: "+req);
        if(auth_app_token){
          //console.log({auth_app_token});
          //console.log({req});
          req = req.clone({
            withCredentials: true,
            setHeaders: {
              Authorization: `Bearer ${localStorage.getItem("auth_app_token")}`
            }
          });
          if(req.method !== 'GET'){
            return next.handle(req);
          }else{
            return this.preventDuplicate(key,req,next);
          }
          //return next.handle(req); 
        }
      }
    }else{
      if(req.method !== 'GET'){
        return next.handle(req);
      }else{
         return this.preventDuplicate(key,req,next);
      }
      //return next.handle(req); 
    }
  }

  protected get authService(): NbAuthService {
    return this.injector.get(NbAuthService);
  }

  preventDuplicate(key:StateKey<string>,req: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<any>>{
    if(isPlatformServer(this.platformId)){
      return next.handle(req).pipe(tap((event) => {
        this.transferState.set(key, (<HttpResponse<any>> event).body);
      }));
    } else {
      console.log("browserPlatForm");
      const storedResponse = this.transferState.get<any>(key, null);
      if (storedResponse) {
        console.log("There's a stored response");
        const response = new HttpResponse({body: storedResponse, status: 200});
        this.transferState.remove(key);
        return of(response);
      } else {
        console.log("No stored response");
        return next.handle(req);
      }
    }
  }
}
